import { useCallback } from 'react';
import { useKeysContext } from './useKeysContext';
import { IKeysModalsCommon } from '../store/keysTypes';
import { KeysModalHook } from '../contexts/KeysContextTypes';

export const useKeysModal = (): KeysModalHook => {
  const { state, dispatch } = useKeysContext();
  const { modalName, mengeModalType, deletionId } = state;

  const openModal = useCallback((modal: IKeysModalsCommon, data?: { id?: string; type?: string }) => {
    dispatch({
      type: 'SET_MODAL_NAME',
      payload: modal,
    });

    // Handle modal-specific data
    if (modal === IKeysModalsCommon.MODAL_MENGE && data?.type) {
      dispatch({
        type: 'SET_MENGE_MODAL_TYPE',
        payload: data.type,
      });
    }

    if (modal === IKeysModalsCommon.MODAL_DELETE_KEY && data?.id) {
      dispatch({
        type: 'SET_DELETION_ID',
        payload: data.id,
      });
    }
  }, [dispatch]);

  const closeModal = useCallback(() => {
    dispatch({
      type: 'SET_MODAL_NAME',
      payload: null,
    });
    
    // Clear modal-specific data
    dispatch({
      type: 'SET_MENGE_MODAL_TYPE',
      payload: null,
    });
    
    dispatch({
      type: 'SET_DELETION_ID',
      payload: null,
    });
  }, [dispatch]);

  const setMengeModalType = useCallback((type: string | null) => {
    dispatch({
      type: 'SET_MENGE_MODAL_TYPE',
      payload: type,
    });
  }, [dispatch]);

  const setDeletionId = useCallback((id: string | null) => {
    dispatch({
      type: 'SET_DELETION_ID',
      payload: id,
    });
  }, [dispatch]);

  // Utility functions
  const isModalOpen = useCallback((modal: IKeysModalsCommon): boolean => {
    return modalName === modal;
  }, [modalName]);

  const isAnyModalOpen = useCallback((): boolean => {
    return modalName !== null;
  }, [modalName]);

  return {
    modalName,
    mengeModalType,
    deletionId,
    openModal,
    closeModal,
    setMengeModalType,
    setDeletionId,
    isModalOpen,
    isAnyModalOpen,
  };
};